import React, {useEffect, useState, useRef} from 'react';
import useApp from 'hooks/useApp'
import {useLocation, useNavigate} from 'react-router-dom'
import styles from 'views/data/index.module.css'
import useCommonIndustry from 'hooks/useCommonIndustry'
import {
    searchDataState,
    best50CountState,
    searchCountState,
    certFromState,
    reqCdState,
    detailResultDataState,
    certTypeState,
    transmitRequestState,
    checkedCountState,
    bestCheckedCountState,
    searchCheckedCountState,
    selectedOrgsState,
    certFromUrlState
} from '../states'
import {orgListState, showBest50LayerState, showSearchLayerState} from './states';
import {consentListState} from 'views/mydata/manage/states'
import {useRecoilState, useRecoilValue, useSetRecoilState, useResetRecoilState} from 'recoil'
import {safeAreaInsetState} from 'states'
import FloatLayer from './components/FloatLayer'
import SearchLayer from './components/SearchLayer'
import Best50Layer from './components/Best50Layer'
import ListItem from './components/ListItem'
import ListItemSkeleton from './components/ListItemSkeleton'
import Lib from 'library'

const Data = () => {
    const App = useApp()
    const location = useLocation()
    const [tabList, setTabList] = useState(0)
    const indsCds = useCommonIndustry()
    const [data, setData] = useRecoilState(orgListState(location.state?.preSelectedOrg)) // 기관목록 데이터  preSelectedOrg: 미리 선택되어 넘겨진 기관

    const setCertFromUrl = useSetRecoilState(certFromUrlState);

    const searchData = useRecoilValue(searchDataState)
    const setSearchCount = useSetRecoilState(searchCountState)
    const setShowSearchLayer = useSetRecoilState(showSearchLayerState)
    const setShowBest50Layer = useSetRecoilState(showBest50LayerState)

    const [checkedCount, setCheckedCount] = useRecoilState(checkedCountState)
    const setBest50Count = useSetRecoilState(best50CountState)
    const setBestCheckedCount = useSetRecoilState(bestCheckedCountState)
    const setSearchedCheckedCount = useSetRecoilState(searchCheckedCountState)
    const setCertFrom = useSetRecoilState(certFromState)

    const resetTransmitRequest = useResetRecoilState(transmitRequestState)
    const resetSelectedOrgs = useResetRecoilState(selectedOrgsState)
    const resetDetailResultData = useResetRecoilState(detailResultDataState)
    const resetReqCd = useResetRecoilState(reqCdState)
    const resetCertType = useResetRecoilState(certTypeState)
    const resetConsentList = useResetRecoilState(consentListState)

    const safeAreaInsets = useRecoilValue(safeAreaInsetState)
    const navigate = useNavigate();

    const page = useRef()

    const [availableTime, setAvailableTime] = useState({})

    // 초기화
    const resetDataList = () => {
        console.log("콤포넌트 종료시점 목록 체크 초기화");
        if (data) {
            const newData = data.map(group => {
                const groupData = group.data.map(item => (
                    {
                        ...item,
                        linked: false,
                        isAvailableTime: true,
                        checked: false
                    }
                ))
                return {
                    ...group,
                    data: groupData,
                    checkedCount: 0
                }
            });
            setData(newData);
        }
    }

    // 연동가능 시간 확인
    /**
     * 응답 예시
     * {insttCd: 'A1AABG0000', rglrTrnspTm: '01:00 ~ 07:00', useYn: 'N'}
     * {insttCd: 'D1AAEV0000', rglrTrnspTm: '06:00 ~ 08:00,03:30 ~ 05:30,01:00 ~ 03:00', useYn: 'N'}
     */
    const checkAvailableTime = () => {
        // 연동가능 시간을 실제로 알 수 있을 때, 다음 주석을 해제하고 사용하면 됩니다.
        // Lib.get("api/data/lnkup/instts/able-time", ableTimeList => {
        //     console.log("ableTimeList", ableTimeList)
        //     const useYList = ableTimeList.filter(instt => instt.useYn === "Y");
        //     const checkAvailableTime = useYList.reduce((json, current) => {
        //         json[current.insttCd] = current.useYn;
        //         return json;
        //     }, {});
        //     console.log("checkAvailableTime", checkAvailableTime)
        //
        //     const useNList = ableTimeList.filter(instt => instt.useYn === "N");
        //     const timeList = useNList.reduce((json, current) => {
        //         json[current.insttCd] = current.rglrTrnspTm.split(",").reduce((stringTimeList, current)=> {
        //             stringTimeList = `${stringTimeList}<li>${current}</li>`
        //             return stringTimeList;
        //         }, "");
        //         return json;
        //     }, {});
        //     console.log("timeList", timeList)
        //     setAvailableTime(timeList);
        //
        //     if (data) {
        //         const newData = data.map(group => {
        //             const groupData = group.data.map(item => (
        //                 {
        //                     ...item,
        //                     isAvailableTime: checkAvailableTime[item.insttCd] === "Y",
        //                 }
        //             ))
        //             return {
        //                 ...group,
        //                 data: groupData,
        //             }
        //         });
        //         console.log("연동가능 시간 확인 후 data 변경", newData)
        //         setData(newData);
        //     }
        // })

        if (data) {
            const newData = data.map(group => {
                const groupData = group.data.map(item => (
                    {
                        ...item,
                        isAvailableTime: true,
                    }
                ))
                return {
                    ...group,
                    data: groupData,
                }
            });
            console.log("연동가능 시간 확인 후 data 변경", newData)
            setData(newData);
        }
    }

    // 기관 연동 확인하기
    const setLinked = async () => {
        const preSelectedOrg = location.state?.preSelectedOrg;
        const preIndstCd = location.state?.preIndstCd;

        await Lib.get("api/data/lnkup/instts/linked", linkedList => {
            console.log("linkedList", linkedList);
            const linkedJson = linkedList.reduce((jsonObject, item) => {
                jsonObject[item.infPrvdrCd] = true; // 연결된 것만 목록 수신됨.
                return jsonObject
            }, {})
            console.log("linkedJson", linkedJson);
            const isLinked = !!linkedJson[preSelectedOrg];

            if (data) {
                const newData = data.map(group => {
                    const groupData = group.data.map(item => (
                        {
                            ...item,
                            linked: linkedJson[item.insttCd] ? linkedJson[item.insttCd] : false,
                            checked: !isLinked && preSelectedOrg && item.insttCd === preSelectedOrg// 화면 진입시, 넘어온 값이 연결되지 않았다면 제외하고 체크 해제
                        }
                    ))
                    return {
                        ...group,
                        data: groupData,
                        checkedCount: !isLinked && preIndstCd && group.indstCd === preIndstCd ? 1 : 0 // 화면 진입시 넘어온 값이 있으면 팝업에 표시하기 위해 카운트 증가(0이상일때만 표시됨)
                        // FloatLayer.js 에서 group.checkedCount > 0 을 체크하기 때문에 1 이상으로 세팅해야 목록이 보임.
                    }
                });
                console.log("data에 연동된 기관 플래그 추가", newData)
                setData(newData);
            }
        });
    }

    const setCheck = cd => {
        let _checkedCount = 0
        let _searchedCount = 0
        let _bestCount = 0

        const newData = data.map(group => {
            let groupCheckedCount = 0
            const data = group.data.map(item => {
                let checked = item.checked ?? false
                if (item.insttCd === cd) {
                    if (item.checked === false) {
                        if (checkedCount >= 50) {
                            App.toast("기관선택은 한번에 50개까지만 가능해요.")
                        } else {
                            checked = true
                        }
                    } else {
                        checked = false
                    }
                }

                if (checked) {
                    _checkedCount++
                    groupCheckedCount++
                }
                if (item.searched) _searchedCount++
                if (item.best50) _bestCount++

                return {
                    ...item,
                    checked: checked
                }
            })
            return {
                ...group,
                checkedCount: groupCheckedCount,
                data: data
            }
        })

        setCheckedCount(_checkedCount)
        setBestCheckedCount(_bestCount)
        setSearchedCheckedCount(_searchedCount)
        setData(newData)
    }

    const showAvailableTime = (item) => {
        const timeList = availableTime[item.insttCd];
        App.alert(`<h3>현재 점검중이예요</br>아래시간에 다시 시도해주세요.</h3><${item.insttNm} 연동가능시간> <ul>${timeList}</ul>`);
    }

    const showAlert = () => {
        const didDataAlert = window.localStorage.getItem("didDataAlert")
        if (didDataAlert !== "true") {
            setTimeout(() => {
                App.alert("마이데이터를 연결하고, 모니를 이용해보세요.")
                window.localStorage.setItem("didDataAlert", "true")
            }, 300)
        }
    }

    const goToSection = (cd, index) => {
        cd = cd.toLowerCase()
        setTabList(index + 1)
        const to = document.querySelector(`#${cd}`)
        const core = document.querySelector(".core")
        if (to) {
            const rect = to.getBoundingClientRect()
            if (core) {
                const scrollTop = core.scrollTop
                setTimeout(() => {
                    core.scrollTop = rect.top - 125 + scrollTop - safeAreaInsets.top
                }, 100)
            }
        }
    }

    const resetAll = () => {
        resetTransmitRequest()
        resetSelectedOrgs()
        resetDetailResultData()
        resetReqCd()
        setCertFrom()
        resetCertType()
        resetConsentList()
    }

    useEffect(() => {
        if (!data) return
        let count = 0
        if (searchData === "") {
            const newData = data.map(group => {
                return {
                    ...group,
                    data: group.data.map(item => {
                        return {
                            ...item,
                            searched: false
                        }
                    }),
                    searchedCount: 0,
                }
            })
            setData(newData)
        } else {
            const regExp = new RegExp(searchData.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), "gi")
            setData(data.map(group => {
                let searchedCount = 0
                let searched
                const data = group.data.map(item => {
                    // [OR조건추가. 20221012]
                    if (regExp.test(item.insttNm) || item.insttNm.indexOf(searchData.trim().toUpperCase()) > -1) {
                        searched = true
                        searchedCount++
                        count++
                    } else {
                        searched = false
                    }
                    return {
                        ...item,
                        searched: searched
                    }
                })
                return {
                    ...group,
                    data: data,
                    searchedCount: searchedCount
                }
            }))
        }
        setSearchCount(count)
    }, [searchData])

    useEffect(() => {
        if (!data) return
        let _checkedCount = 0
        let _searchedCount = 0
        let _bestCount = 0
        let _best50Count = 0

        data.forEach(group => {
            const data = group.data.map(item => {
                let searchedCount = item.searchCount
                let bestCount = item.bestCount
                if (item.checked) {
                    _checkedCount++
                    if (item.searched) _searchedCount++
                    if (item.best50) _bestCount++
                }

                if (item.searched) searchedCount++
                if (item.best50) {
                    bestCount++
                    _best50Count++
                }
                return {
                    ...item,
                    searchedCount: searchedCount,
                    bestCount: bestCount
                }
            })
            return {
                ...group,
                data: data,
                checkedCount: 0,
                searchedCount: 0,
                bestCount: 0
            }
        })

        setCheckedCount(_checkedCount)
        setBestCheckedCount(_bestCount)
        setSearchedCheckedCount(_searchedCount)
        setBest50Count(_best50Count)
    }, [data])

    const goBackConfirm = () => {
        App.confirm("마이데이터 연결을 취소합니다. ", () => {
            let from = location.state?.from;

            if (from != null) navigate(from, {replace: true});
            else navigate("/");
        })
    }

    useEffect(() => {
        App.setHeader({
            show: true,
            title: <></>,
            left: <i className="icon icon_arrow_back" onClick={goBackConfirm}/>,
            right: <i className="icon icon_search" onClick={() => setShowSearchLayer(true)}/>,
            className: "translucent"
        })

        App.setShowNav(false)
        App.setMainClass("white")

        showAlert()

        // - recoil 로 대체

        page.current.closest("main").classList.add("dataHome")

        resetAll()

        setCertFromUrl(location.state?.from);

        // 서비스 점검시간 체크 (23:30 ~ 00:30)
        const today = new Date();
        const hh = ("0" + today.getHours()).slice(-2)
        const mm = ("0" + today.getMinutes()).slice(-2)
        if ((Number(hh) >= 23 && Number(mm) >= 30) || (Number(hh) <= 0 && Number(mm) <= 30)) {
            App.showAlert({
                title: "시스템 정기점검 안내",
                msg: "매일 23:30~00:30분까지는 시스템 점검으로<br />데이터 연동이 불가능합니다.",
                type: "bottom",
                confirm: false,
                onOk() {
                    //navigate('/home', {replace: true})
                    navigate('/mydata')
                }
            })
        }

        setLinked().then(checkAvailableTime); // 연동 연결됨 표시여부 -> 연동가능 시간 확인

        return () => {
            resetDataList(); // 종료시 초기화 (재진입시 숫자가 표시되었다가 사라지는 것보다, 0에서 증가하는 것이 낫다.
            document.querySelectorAll("main").forEach(element => {
                element.classList.remove("dataHome")
            })
        }
    }, [])

    useEffect(() => {
        let preIndstCd = location.state?.preIndstCd;
        if (preIndstCd != null && tabList != null) {
            preIndstCd = preIndstCd.toLowerCase();
            data.some(function (item, index) {
                if (item.indstCd == preIndstCd) {
                    return goToSection(preIndstCd, index)
                }
            })
        }
    }, [])

    return (
        <div className="page" ref={page}>
            <div className={`${styles["count-group"]} padding`}>
                <p>연결할 기관 선택</p>
                <div><span>1</span>/3</div>
            </div>

            <MainBar
                setTabList={setTabList}
                setShowBest50Layer={setShowBest50Layer}
                goToSection={goToSection}
                indsCds={indsCds}
                tabList={tabList}
            />

            <MainList data={data} setCheck={setCheck} showAvailableTime={showAvailableTime}/>

            <FloatLayer from={location.state?.from} data={data} setCheck={setCheck}/>
            <Best50Layer setCheck={setCheck}/>
            <SearchLayer data={data} setCheck={setCheck}/>
        </div>
    )
}

const MainBar = ({setTabList, goToSection, indsCds, tabList}) => {

    const setShowBest50Layer = useSetRecoilState(showBest50LayerState)

    return (
        <div className="no-scroll sticky"
             style={{overflowX: "auto", top: "calc(var(--safe-area-inset-top) + var(--header-height))", flexShrink: 0}}>
            <ul className="tab-round no-wrap translucent">
                <li onClick={() => {
                    setTabList(0)
                    setShowBest50Layer(true)
                }} className="active flex-align_center">BEST <i className="icon icon_tab_best ml_5"/></li>
                {
                    indsCds &&
                    indsCds.map((item, index) => <li key={index} onClick={() => goToSection(item.commCd, index)}
                                                     className={`${tabList === index + 1 ? "active" : ""} flex-align_center`}>{item.commNm}</li>)
                }
            </ul>
        </div>
    )
}

const MainList = ({data, setCheck, showAvailableTime}) => (
    <div className="padding" style={{paddingBottom: "17rem"}}>
        <ul className="check-area mt_10">
            {
                data ? data.map(group => {
                        return <ListItem key={group.indstCd} group={group} setCheck={setCheck}
                                         showAvailableTime={showAvailableTime}/>
                    })
                    :
                    <ListItemSkeleton/>
            }
        </ul>
    </div>
)

export default Data